var assign = require('object-assign');

var Constants = require('../constants/Constants');
var BaseStore = require('./BaseStore');
var LocalStorage = require('../util/LocalStorage');

var TokenStore = new BaseStore();

TokenStore.getToken = function () {
    return LocalStorage.get('token');
};
TokenStore.setToken = function (token) {
    LocalStorage.set('token', token);

    this.emitChange();
};

module.exports = TokenStore;



// WEBPACK FOOTER //
// ./app/stores/TokenStore.js